
import {
    includeRule,
    hideOptionSet
  }
  from './rules_functions.js';
  
  
export function rules_bmetc(newState, state) {
    var newrule = includeRule(newState, state, 'bmetc')
    
    var show =  hideOptionSet(newState, state, [ ['band', [ '0']]])
    if (show == true)  
       show =  hideOptionSet(newState, state, [ ['bmet', [ 'PT']]])
    
      
    newrule['show']  = show
    return newrule
}